var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCross(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3553 0.39375C13.8876 -0.0739582 13.1292 -0.0739582 12.6615 0.39375L7.74949 5.30609L2.83745 0.39375C2.36977 -0.0739582 1.61141 -0.0739582 1.14373 0.39375C0.676049 0.861457 0.676049 1.61987 1.14373 2.08758L6.05577 6.99949L1.14416 11.9114C0.676476 12.3791 0.676476 13.1375 1.14416 13.6052C1.61183 14.0729 2.3702 14.0729 2.83788 13.6052L7.74949 8.69289L12.6615 13.6052C13.1292 14.0729 13.8876 14.0729 14.3553 13.6052C14.8229 13.1375 14.8229 12.3791 14.3553 11.9114L9.44321 6.99906L14.3553 2.08672C14.8229 1.61901 14.8229 0.861457 14.3553 0.39375Z",
    fill: "#013165"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.277cb097ab4630da56f37503d26a7b8c.svg";
export { ForwardRef as ReactComponent };